// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__hTZoh","spin":"Loader_spin__n51XF"};